/* Source: /app/utils/ProtectedRoute.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useEffect } from "react";
import { Navigate, jacIsLoggedIn } from "@jac/runtime";
function ProtectedRoute(props) {
  const {p} = props;
  if (!jacIsLoggedIn()) {
    return __jacJsx(Navigate, {"to": "/login"}, []);
  }
  return p.children;
}
/*jac:refresh-boundary*/;
export {ProtectedRoute};
//# sourceMappingURL=ProtectedRoute.js.map
